import { Button, DownloadOutlineIcon } from '@mr-yum/frontend-ui'
import cn from 'classnames'
import React, { HTMLAttributes } from 'react'
import { FormattedMessage } from 'react-intl'

import { FloatingButton } from '@/components/Shared/FloatingButton'

import { Company } from './types'

export const dateFormat = 'do MMM yyyy, h:mm aa'

export enum CURRENCIES {
  NZD,
  AUD,
  USD,
  GBP,
  EUR,
  ZAR,
  CHF,
  DKK,
  NOK,
  SEK,
  SGD,
}

export const displayCompanyList: {
  [currency in keyof typeof CURRENCIES]: Company
} = {
  AUD: {
    name: 'me&u Trading Pty Ltd',
    regNum: 'ABN: 17 631 694 132',
    email: 'receipts@meandu.com',
    taxName: 'GST',
  },
  NZD: {
    name: 'me&u Trading Pty Ltd',
    regNum: 'NZBN: 9429048145671',
    email: 'receipts@meandu.com',
    taxName: 'GST',
  },
  ZAR: {
    name: 'Everdine (Pty) Ltd T/A me&u SA',
    regNum: 'Reg: 2020 / 105789 / 07',
    email: 'receipts.sa@mryum.com',
    taxName: 'VAT',
  },
  USD: {
    name: 'me&u Trading Inc',
    regNum: 'TAX ID: 85-2322073',
    email: 'receipts@meandu.com',
    taxName: 'Sales tax',
  },
  GBP: {
    name: 'me&u Trading Ltd',
    regNum: 'Company number: 13055559',
    email: 'receipts@meandu.com',
    taxName: 'VAT',
  },
  EUR: {
    name: 'me&u Trading Ltd',
    regNum: 'Company number: 13055559',
    email: 'receipts@meandu.com',
    taxName: 'VAT',
  },
  CHF: {
    name: 'me&u Trading Ltd',
    regNum: 'Company number: 13055559',
    email: 'receipts@meandu.com',
    taxName: 'VAT',
  },
  NOK: {
    name: 'me&u Trading Ltd',
    regNum: 'Company number: 13055559',
    email: 'receipts@meandu.com',
    taxName: 'VAT',
  },
  SEK: {
    name: 'me&u Trading Ltd',
    regNum: 'Company number: 13055559',
    email: 'receipts@meandu.com',
    taxName: 'VAT',
  },
  DKK: {
    name: 'me&u Trading Ltd',
    regNum: 'Company number: 13055559',
    email: 'receipts@meandu.com',
    taxName: 'VAT',
  },
  SGD: {
    name: 'me&u Trading Ltd',
    regNum: '',
    email: 'receipts@meandu.com',
    taxName: 'GST',
  },
}

export const InvoiceLink = ({
  href,
  className,
  children,
  ...props
}: React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
  return (
    <a
      className={cn('text-inherit hover:underline', className)}
      href={href}
      {...props}
    >
      {children}
    </a>
  )
}

export const Table = ({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn(
        'h-unset mb-6 flex flex-col overscroll-x-auto border-b pb-6 text-foreground',
        className,
      )}
      {...props}
      role="grid"
    >
      {children}
    </div>
  )
}

export const TableBody = ({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn(
        'w-full flex-1 overflow-x-hidden overflow-y-overlay',
        className,
      )}
      {...props}
      role="rowgroup"
    >
      {children}
    </div>
  )
}

export const TableRow = ({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cn('flex items-center', className)} role="row" {...props}>
      {children}
    </div>
  )
}

export const TableHead = ({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn('mb-1 flex w-full flex-grow-0', className)}
      role="row"
      {...props}
    >
      {children}
    </div>
  )
}

export const TableHeadCell = ({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn('mb-1 flex w-full justify-between my-label-md', className)}
      role="columnheader"
      {...props}
    >
      {children}
    </div>
  )
}

export const TableCell = ({
  children,
  className,
  isBold = false,
  ...props
}: HTMLAttributes<HTMLDivElement> & { isBold?: boolean }) => {
  return (
    <div
      className={cn(
        'mb-1 block',
        {
          'my-body-md': !isBold,
          'my-body-md-bold': isBold,
        },
        className,
      )}
      role="grid"
      {...props}
    >
      {children}
    </div>
  )
}

export const DownloadPDF = ({ href }: { href: any }) => {
  return (
    <FloatingButton>
      <Button as="a" size="lg" href={href} fullWidth>
        <div className="flex items-center justify-center">
          <span className="mr-2">
            <DownloadOutlineIcon />
          </span>

          <span>
            <FormattedMessage defaultMessage="Download PDF" id="TclprG" />
          </span>
        </div>
      </Button>
    </FloatingButton>
  )
}
